// styles
import styles from "../../styles/Tabs.module.css";

interface TabProps {
  name: string;
  tab: {
    name: string;
    light: string;
    dark: string;
  };
  changeTab: (tab: string) => void;
  activeTab: string;
  displaySecondRow: boolean;
}

const Tab: React.FC<TabProps> = ({
  name,
  tab,
  changeTab,
  activeTab,
  displaySecondRow,
}) => {
  return (
    <div
      className={`${styles.tab} ${activeTab === name ? styles.activeTab : ''} ${displaySecondRow ? styles.smallImg : styles.bigImg}`}
      onClick={() => changeTab(name)}
      role="tab"
      aria-controls={`panel-id-${name}`}
      aria-selected={activeTab === name}
      id={`tab-id-${name}`}
    >
      <img src={activeTab === name ? tab?.light : tab?.dark} alt="vehicle type icon" />
    </div>
  )
};

export default Tab;
